import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Contact() {
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen h-screen overflow-y-auto"
      style={{ backgroundColor: 'var(--color-bg-primary)' }}
    >
      <div className="max-w-3xl mx-auto px-6 py-12">
        {/* Header */}
        <div className="mb-8">
          <Link
            to="/"
            className="text-sm hover:underline"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            {t('contact.backToHome')}
          </Link>
        </div>

        <h1
          className="text-3xl font-bold mb-8"
          style={{ color: 'var(--color-text-primary)' }}
        >
          {t('contact.title')}
        </h1>

        <div
          className="space-y-8 text-sm leading-relaxed"
          style={{ color: 'var(--color-text-secondary)' }}
        >
          <section>
            <p className="mb-6">
              {t('contact.intro')}
            </p>

            <div
              className="p-6 rounded-lg"
              style={{
                backgroundColor: 'var(--color-bg-secondary)',
                border: '1px solid var(--color-border)',
              }}
            >
              <h2
                className="text-lg font-semibold mb-4"
                style={{ color: 'var(--color-text-primary)' }}
              >
                {t('contact.generalInquiries')}
              </h2>
              <p className="mb-2">
                {t('contact.generalInquiriesDesc')}
              </p>
              <a
                href="mailto:contact-pelo1@baselabs.co.kr"
                className="text-base font-medium hover:underline"
                style={{ color: 'var(--color-accent-red)' }}
              >
                contact-pelo1@baselabs.co.kr
              </a>
            </div>

            <div
              className="p-6 rounded-lg mt-4"
              style={{
                backgroundColor: 'var(--color-bg-secondary)',
                border: '1px solid var(--color-border)',
              }}
            >
              <h2
                className="text-lg font-semibold mb-4"
                style={{ color: 'var(--color-text-primary)' }}
              >
                {t('contact.privacyConcerns')}
              </h2>
              <p className="mb-2">
                {t('contact.privacyConcernsDesc')}
              </p>
              <a
                href="mailto:privacy-pelo1@baselabs.co.kr"
                className="text-base font-medium hover:underline"
                style={{ color: 'var(--color-accent-red)' }}
              >
                privacy-pelo1@baselabs.co.kr
              </a>
            </div>
          </section>

          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              <a href="https://baselabs.co.kr" target="_blank" rel="noopener noreferrer" className="hover:underline">
                {t('contact.aboutBaseLabs')}
              </a>
            </h2>
            <p>
              {t('contact.aboutBaseLabsDesc')}
            </p>
          </section>
        </div>

        {/* Footer */}
        <div
          className="mt-12 pt-8 border-t text-center text-sm"
          style={{
            borderColor: 'var(--color-border)',
            color: 'var(--color-text-muted)',
          }}
        >
          <div className="flex justify-center gap-4 mb-2">
            <Link
              to="/terms"
              className="hover:underline"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              {t('contact.terms')}
            </Link>
            <span style={{ color: 'var(--color-border)' }}>|</span>
            <Link
              to="/privacy"
              className="hover:underline"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              {t('contact.privacyPolicy')}
            </Link>
            <span style={{ color: 'var(--color-border)' }}>|</span>
            <Link
              to="/contact"
              className="hover:underline"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              {t('contact.contact')}
            </Link>
          </div>
          © 2025 <a href="https://baselabs.co.kr" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: 'var(--color-text-secondary)' }}>BaseLabs Corp.</a> {t('contact.copyright')}
        </div>
      </div>
    </div>
  );
}
